import { CalendarDays } from "lucide-react";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// Impression-weighted completion, ignoring the unbranded "Other" bucket
export const ctvCompletion = (publishers = []) => {
  const named = publishers.filter((p) => !p.is_other && p.completion_rate > 0);
  const imp = named.reduce((s, p) => s + (p.impressions || 0), 0);
  return imp ? named.reduce((s, p) => s + p.completion_rate * (p.impressions || 0), 0) / imp : 0;
};

const joinList = (items) => (items.length < 2 ? items.join("") : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`);

const monthPhrase = (months) => {
  const years = [...new Set(months.map((m) => m.month.slice(0, 4)))];
  const label = (m) => MONTHS[Number(m.month.slice(5, 7)) - 1] + (years.length > 1 ? ` ${m.month.slice(0, 4)}` : "");
  return joinList(months.map(label)) + (years.length === 1 ? ` ${years[0]}` : "");
};

export const CtvMonths = ({ months = [] }) => {
  if (!months.length) return null;
  return (
    <div className="flex items-start gap-3 bg-white/5 border border-purple-400/20 rounded-xl px-4 py-3 mb-6" data-testid="ctv-months">
      <CalendarDays className="w-5 h-5 text-purple-300 flex-shrink-0 mt-0.5" />
      <p className="text-white text-sm md:text-base">
        <span className="text-purple-300 font-semibold">Ran in </span>
        <span data-testid="ctv-months-list">{monthPhrase(months)}</span>
      </p>
    </div>
  );
};

const Tile = ({ value, label, color, testId }) => (
  <div className="bg-white/10 rounded-xl px-4 py-4 md:px-6 border border-white/10 min-w-0" data-testid={testId}>
    <p className={`text-2xl sm:text-3xl md:text-4xl font-bold tabular-nums ${color}`}>{value}</p>
    <p className="text-slate-400 text-sm">{label}</p>
  </div>
);

export const CtvTiles = ({ publishers, conversions }) => {
  const impressions = publishers.reduce((s, p) => s + (p.impressions || 0), 0);
  const completion = ctvCompletion(publishers);
  const convTotal = conversions.reduce((s, c) => s + (c.count || 0), 0);
  return (
    <div className="mb-2">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
        <Tile value={impressions.toLocaleString()} label="times your ad played" color="text-purple-300" testId="ctv-total-impressions" />
        {completion > 0 && <Tile value={`${completion.toFixed(1)}%`} label="watched to the end" color="text-emerald-400" testId="ctv-completion-rate" />}
        {convTotal > 0 && (
          <Tile value={convTotal.toLocaleString()} label="visited your website after" color="text-amber-400" testId="ctv-conversions-total" />
        )}
      </div>
      <p className="text-slate-300 text-base md:text-lg">
        Viewers are watching your <span className="text-white font-semibold">full message</span> on the biggest screen in their home.
        {convTotal > 0 && <> People who saw your CTV ad then <span className="text-amber-300 font-semibold">visited your website</span>.</>}
      </p>
    </div>
  );
};
